import React, { useState } from 'react';
import { BookOpenIcon, InstagramIcon, FacebookIcon, TwitterIcon } from 'lucide-react';
import { Modal } from './Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const openModal = (modalType: string) => {
    setActiveModal(modalType);
  };
  const closeModal = () => {
    setActiveModal(null);
  };
  return <footer className="bg-amber-800 text-amber-100 py-12" data-id="element-102">
      <div className="container mx-auto px-4" data-id="element-103">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-104">
          <div className="flex items-center space-x-2 mb-6 md:mb-0" data-id="element-105">
            <BookOpenIcon className="h-6 w-6" data-id="element-106" />
            <span className="font-bold text-xl" data-id="element-107">RecetasExpress</span>
          </div>
          <div className="flex space-x-4" data-id="element-108">
            <SocialIcon icon={<InstagramIcon className="h-5 w-5" data-id="element-110" />} data-id="element-109" />
            <SocialIcon icon={<FacebookIcon className="h-5 w-5" data-id="element-112" />} data-id="element-111" />
            <SocialIcon icon={<TwitterIcon className="h-5 w-5" data-id="element-114" />} data-id="element-113" />
          </div>
        </div>
        <div className="border-t border-amber-700 pt-8 mt-8 text-center text-sm" data-id="element-115">
          <p className="mb-2" data-id="element-116">
            © 2025 RecetasExpress. Todos los derechos reservados.
          </p>
          <div className="flex justify-center space-x-4 mt-4" data-id="element-117">
            <button onClick={() => openModal('terms')} className="hover:text-white transition" data-id="element-118">
              Términos y Condiciones
            </button>
            <button onClick={() => openModal('privacy')} className="hover:text-white transition" data-id="element-119">
              Política de Privacidad
            </button>
            <button onClick={() => openModal('contact')} className="hover:text-white transition" data-id="element-120">
              Contacto
            </button>
          </div>
        </div>
      </div>
      {/* Términos y Condiciones Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={closeModal} title="Términos y Condiciones" data-id="element-121">
        <div className="space-y-4 text-amber-900" data-id="element-122">
          <h3 className="font-semibold text-lg" data-id="element-123">
            1. Aceptación de los Términos
          </h3>
          <p data-id="element-124">
            Al adquirir nuestro ebook "20 Cenas Listas en 15 Minutos", usted
            acepta estos términos y condiciones en su totalidad. Si no está de
            acuerdo con estos términos, por favor no realice la compra.
          </p>
          <h3 className="font-semibold text-lg" data-id="element-125">2. Propiedad Intelectual</h3>
          <p data-id="element-126">
            Todo el contenido incluido en el ebook, incluyendo recetas, imágenes
            y textos, está protegido por derechos de autor y pertenece a
            RecetasExpress. Está prohibida la reproducción, distribución o venta
            del contenido sin autorización expresa.
          </p>
          <h3 className="font-semibold text-lg" data-id="element-127">3. Uso Personal</h3>
          <p data-id="element-128">
            La compra del ebook otorga una licencia para uso personal
            únicamente. No está permitido compartir el archivo digital con
            terceros.
          </p>
          <h3 className="font-semibold text-lg" data-id="element-129">4. Política de Reembolso</h3>
          <p data-id="element-130">
            Debido a la naturaleza digital del producto, no ofrecemos reembolsos
            una vez que el ebook ha sido descargado. Si tiene problemas técnicos
            con la descarga, contáctenos y le ayudaremos a resolverlos.
          </p>
          <h3 className="font-semibold text-lg" data-id="element-131">
            5. Limitación de Responsabilidad
          </h3>
          <p data-id="element-132">
            RecetasExpress no se hace responsable por alergias, intolerancias o
            cualquier problema de salud relacionado con la preparación o consumo
            de las recetas incluidas. Consulte a un profesional de la salud si
            tiene dudas específicas.
          </p>
        </div>
      </Modal>
      {/* Política de Privacidad Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" data-id="element-133">
        <div className="space-y-4 text-amber-900" data-id="element-134">
          <h3 className="font-semibold text-lg" data-id="element-135">
            1. Información que Recopilamos
          </h3>
          <p data-id="element-136">
            Al realizar la compra, recopilamos información personal como su
            nombre, dirección de correo electrónico y datos de pago. Esta
            información es necesaria para procesar su compra y entregarle el
            producto.
          </p>
          <h3 className="font-semibold text-lg" data-id="element-137">2. Uso de la Información</h3>
          <p data-id="element-138">Utilizamos su información para:</p>
          <ul className="list-disc pl-5" data-id="element-139">
            <li data-id="element-140">Procesar y completar su compra</li>
            <li data-id="element-141">Enviarle el ebook y la confirmación de compra</li>
            <li data-id="element-142">Comunicarnos con usted sobre su pedido</li>
            <li data-id="element-143">
              Enviarle actualizaciones o promociones (solo si ha dado su
              consentimiento)
            </li>
          </ul>
          <h3 className="font-semibold text-lg" data-id="element-144">3. Protección de Datos</h3>
          <p data-id="element-145">
            Implementamos medidas de seguridad adecuadas para proteger su
            información personal contra acceso no autorizado, alteración,
            divulgación o destrucción.
          </p>
          <h3 className="font-semibold text-lg" data-id="element-146">4. Cookies</h3>
          <p data-id="element-147">
            Nuestro sitio utiliza cookies para mejorar su experiencia. Puede
            configurar su navegador para rechazar cookies, pero esto puede
            afectar la funcionalidad del sitio.
          </p>
          <h3 className="font-semibold text-lg" data-id="element-148">5. Derechos del Usuario</h3>
          <p data-id="element-149">
            Tiene derecho a acceder, corregir o eliminar su información
            personal. Para ejercer estos derechos, contáctenos a través de
            nuestro formulario de contacto.
          </p>
        </div>
      </Modal>
      {/* Contacto Modal */}
      <Modal isOpen={activeModal === 'contact'} onClose={closeModal} title="Contacto" data-id="element-150">
        <div className="space-y-6 text-amber-900" data-id="element-151">
          <p data-id="element-152">
            Estamos aquí para ayudarte. Completa el siguiente formulario y nos
            pondremos en contacto contigo lo antes posible.
          </p>
          <form className="space-y-4" data-id="element-153">
            <div data-id="element-154">
              <label htmlFor="name" className="block text-amber-800 mb-1" data-id="element-155">
                Nombre
              </label>
              <input type="text" id="name" className="w-full px-3 py-2 border border-amber-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="Tu nombre" data-id="element-156" />
            </div>
            <div data-id="element-157">
              <label htmlFor="email" className="block text-amber-800 mb-1" data-id="element-158">
                Correo electrónico
              </label>
              <input type="email" id="email" className="w-full px-3 py-2 border border-amber-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="tu@email.com" data-id="element-159" />
            </div>
            <div data-id="element-160">
              <label htmlFor="subject" className="block text-amber-800 mb-1" data-id="element-161">
                Asunto
              </label>
              <select id="subject" className="w-full px-3 py-2 border border-amber-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" data-id="element-162">
                <option value="" data-id="element-163">Selecciona un asunto</option>
                <option value="purchase" data-id="element-164">Problema con la compra</option>
                <option value="download" data-id="element-165">Problema con la descarga</option>
                <option value="content" data-id="element-166">Pregunta sobre el contenido</option>
                <option value="other" data-id="element-167">Otro</option>
              </select>
            </div>
            <div data-id="element-168">
              <label htmlFor="message" className="block text-amber-800 mb-1" data-id="element-169">
                Mensaje
              </label>
              <textarea id="message" rows={4} className="w-full px-3 py-2 border border-amber-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500" placeholder="Escribe tu mensaje aquí..." data-id="element-170"></textarea>
            </div>
            <button type="submit" className="w-full bg-amber-600 hover:bg-amber-700 text-white font-medium py-2 px-4 rounded-md transition" data-id="element-171">
              Enviar mensaje
            </button>
          </form>
          <div className="pt-4 border-t border-amber-200" data-id="element-172">
            <p className="font-semibold" data-id="element-173">
              También puedes contactarnos directamente:
            </p>
            <p className="mt-2" data-id="element-174">Email: contacto@recetasexpress.com</p>
            <p data-id="element-175">Teléfono: +34 123 456 789</p>
          </div>
        </div>
      </Modal>
    </footer>;
}
function SocialIcon({
  icon
}) {
  return <a href="#" className="bg-amber-700 p-2 rounded-full hover:bg-amber-600 transition" data-id="element-176">
      {icon}
    </a>;
}